import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import {
	appCreateMembership,
	appDeleteMembership,
	appGetSansthaById,
	appUpdateMembership,
	appUpdateSanstha,
} from '../../store/sanstha'
import swal from 'sweetalert'
import { toast } from 'react-toastify'

function MembershipPaymentdetailsTab({ sansthaDetails }) {
	const dispatch = useDispatch()

	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editSansthaId, setEditSansthaId] = useState(null)

	const paymentFormik = useFormik({
		initialValues: {
			upi_id: sansthaDetails?.upi_id || '',
			account_name: sansthaDetails?.account_name || sansthaDetails?.accountName || '',
			account_number: sansthaDetails?.account_number || sansthaDetails?.accountNumber || '',
			bank_name: sansthaDetails?.bank_name || sansthaDetails?.bankName || '',
			branch_name: sansthaDetails?.branch_name || sansthaDetails?.branchName || '',
			ifsc_code: sansthaDetails?.ifsc_code || sansthaDetails?.ifscCode || '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			upi_id: Yup.string()
				.required('UPI ID is required')
				.matches(/^[\w.-]+@[\w.-]+$/, 'Enter a valid UPI ID'),
			account_name: Yup.string()
				.trim()
				.required('Account name is required'),
			account_number: Yup.string()
				.trim()
				.required('Account number is required')
				.matches(/^[0-9]{6,18}$/, 'Enter a valid account number'),
			bank_name: Yup.string()
				.trim()
				.required('Bank name is required'),
			branch_name: Yup.string()
				.trim()
				.required('Branch name is required'),
			ifsc_code: Yup.string()
				.trim()
				.required('IFSC code is required')
				.matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter a valid IFSC code'),
		}),
		onSubmit: async values => {
			const payload = {
				id: sansthaDetails?._id,
				upi_id: values.upi_id,
				account_name: values.account_name,
				account_number: values.account_number,
				bank_name: values.bank_name,
				branch_name: values.branch_name,
				ifsc_code: values.ifsc_code.toUpperCase(),
			}

			try {
				await dispatch(appUpdateSanstha(payload)).unwrap()
				dispatch(appGetSansthaById(sansthaDetails?._id))
				toast.success('Payment details saved successfully')
			} catch (error) {
				toast.error('Something went wrong. Please try again.')
				console.error('Payment details update error:', error)
			}
		},
	})

	const Formik = useFormik({
		initialValues: {
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			membershipType: Yup.string().required('Select duration'),
			honoraryReason: Yup.string().when('membershipType', {
				is: val =>
					val === 'Free( Honorary) with voting right' ||
					val === 'Family member ( free and without voting right)',
				then: Yup.string().required('Honorary reason is required'),
				otherwise: Yup.string().notRequired(),
			}),
			membershipfee: Yup.number().when('membershipType', {
				is: val =>
					val !== 'Free( Honorary) with voting right' &&
					val !== 'Family member ( free and without voting right)',
				then: Yup.number().required('Membership fee is required'),
				otherwise: Yup.number().notRequired(),
			}),
		}),

		onSubmit: async values => {
			const selectedType = values.membershipType

			const existingTypes = sansthaDetails?.membership?.map(m => m.membershipType) || []
			const isDuplicate = existingTypes.includes(selectedType)

			if (!editMode && isDuplicate) {
				toast.error(`${selectedType} membership already exists.`)
				return
			}
			const isHonorary =
				selectedType === 'Free( Honorary) with voting right' ||
				selectedType === 'Family member ( free and without voting right)'
			const membershipPayload = {
				membershipType: selectedType,
				membershipfee: values.membershipfee,
				...(isHonorary
					? { honoraryReason: values.honoraryReason }
					: { membershipfee: values.membershipfee }),
			}
			//  console.log(membershipPayload, "membershipPayload");
			const basePayload = {
				sansthaId: sansthaDetails?._id,
				membership: membershipPayload,
			}
			//   console.log(basePayload, "basePayload");
			try {
				if (editMode && editSansthaId) {
					const payload = {
						...basePayload,
						membershipId: editSansthaId,
					}
					//    console.log(payload, "payload");

					dispatch(appUpdateMembership(payload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				} else {
					//    console.log(basePayload);
					dispatch(appCreateMembership(basePayload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				}

				setShowModal(false)
				setEditMode(false)
				setEditSansthaId(null)
				Formik.resetForm()
			} catch (error) {
				toast.error('Something went wrong. Please try again.')
				console.error('Membership create/update error:', error)
			}
		},
	})

	const handleEditMembership = sanstha => {
		// console.log(sanstha);
		setEditMode(true)
		setEditSansthaId(sanstha?._id || null)

		Formik.setValues({
			membershipType: sanstha?.membershipType || '',
			membershipfee: sanstha?.membershipfee || '',
			honoraryReason: sanstha.honoraryReason || '',
		})

		setShowModal(true)
	}

	const handleDeleteMembership = membershipId => {
		//  console.log(membershipId);
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Membership?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(
					appDeleteMembership({
						sansthaId: sansthaDetails?._id,
						membershipId,
					}),
				).then(() => {
					dispatch(appGetSansthaById(sansthaDetails?._id))
				})
			}
		})
	}

	const handleAddNewMembership = () => {
		setEditMode(false)
		setEditSansthaId(null)
		Formik.resetForm()
		Formik.setValues({
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
		})
		setShowModal(true)
	}

	return (
		<div>
			<div className="d-flex justify-content-end mb-2 flex-wrap">
				<button className="btn btn-sm btn-primary mt-2 mt-md-0" onClick={handleAddNewMembership}>
					<i className="far fa-plus"></i> Add New Membership Type
				</button>
			</div>
			<div
				className="mb-3 p-2"
				style={{
					border: '1px solid #e5e7eb',
					borderRadius: '8px',
					backgroundColor: '#fff',
				}}
			>
				<div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
					<div>
						<h6 className="mb-0">Payment Details</h6>
						<small className="text-muted">
							Fill all fields and save the bank details used for membership payments.
						</small>
					</div>
				</div>

				<form onSubmit={paymentFormik.handleSubmit}>
					<div className="row">
						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">UPI ID *</label>
								<input
									type="text"
									className="form-control form-control-sm"
									name="upi_id"
									value={paymentFormik.values.upi_id}
									onChange={paymentFormik.handleChange}
									onBlur={paymentFormik.handleBlur}
									placeholder="example@bank"
								/>
								{paymentFormik.touched.upi_id && paymentFormik.errors.upi_id && (
									<div className="text-danger small">{paymentFormik.errors.upi_id}</div>
								)}
							</div>
						</div>

						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">Account Name *</label>
								<input
									type="text"
									className="form-control form-control-sm"
									name="account_name"
									value={paymentFormik.values.account_name}
									onChange={paymentFormik.handleChange}
									onBlur={paymentFormik.handleBlur}
									placeholder="Account holder name"
								/>
								{paymentFormik.touched.account_name && paymentFormik.errors.account_name && (
									<div className="text-danger small">{paymentFormik.errors.account_name}</div>
								)}
							</div>
						</div>

						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">Account Number *</label>
								<input
									type="text"
									className="form-control form-control-sm"
									name="account_number"
									value={paymentFormik.values.account_number}
									onChange={paymentFormik.handleChange}
									onBlur={paymentFormik.handleBlur}
									placeholder="Account number"
								/>
								{paymentFormik.touched.account_number && paymentFormik.errors.account_number && (
									<div className="text-danger small">{paymentFormik.errors.account_number}</div>
								)}
							</div>
						</div>

						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">Bank Name *</label>
								<input
									type="text"
									className="form-control form-control-sm"
									name="bank_name"
									value={paymentFormik.values.bank_name}
									onChange={paymentFormik.handleChange}
									onBlur={paymentFormik.handleBlur}
									placeholder="Bank name"
								/>
								{paymentFormik.touched.bank_name && paymentFormik.errors.bank_name && (
									<div className="text-danger small">{paymentFormik.errors.bank_name}</div>
								)}
							</div>
						</div>

						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">Branch Name *</label>
								<input
									type="text"
									className="form-control form-control-sm"
									name="branch_name"
									value={paymentFormik.values.branch_name}
									onChange={paymentFormik.handleChange}
									onBlur={paymentFormik.handleBlur}
									placeholder="Branch name"
								/>
								{paymentFormik.touched.branch_name && paymentFormik.errors.branch_name && (
									<div className="text-danger small">{paymentFormik.errors.branch_name}</div>
								)}
							</div>
						</div>

						<div className="col-lg-2 col-md-4">
							<div className="form-group mb-2">
								<label className="mb-1">IFSC Code *</label>
								<input
									type="text"
									className="form-control form-control-sm text-uppercase"
									name="ifsc_code"
									value={paymentFormik.values.ifsc_code}
									onChange={event =>
										paymentFormik.setFieldValue('ifsc_code', event.target.value.toUpperCase())
									}
									onBlur={paymentFormik.handleBlur}
									placeholder="ABCD0123456"
								/>
								{paymentFormik.touched.ifsc_code && paymentFormik.errors.ifsc_code && (
									<div className="text-danger small">{paymentFormik.errors.ifsc_code}</div>
								)}
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-end mt-1">
						<button
							className="btn btn-sm btn-primary"
							type="submit"
							disabled={paymentFormik.isSubmitting}
						>
							<span className="btn-label mr-1">
								<i className="fa fa-check"></i>
							</span>
							Save Payment Details
						</button>
					</div>
				</form>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>Membership Duration </th>
							<th>Membership Fee/Reason</th>

							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{sansthaDetails?.membership && sansthaDetails.membership.length > 0 ? (
							sansthaDetails.membership.map((membership, index) => (
								<tr key={membership._id || index}>
									<td>{index + 1}</td>
									<td>{membership.membershipType}</td>
									<td>
										{membership.membershipType === 'Free( Honorary) with voting right' ||
										membership.membershipType === 'Family member ( free and without voting right)'
											? membership.honoraryReason
											: membership.membershipfee}
									</td>
									<td>
										<button
											className="btn btn-sm btn-primary mr-2"
											title="Edit"
											onClick={() => handleEditMembership(membership)}
										>
											<i className="far fa-edit"></i>
										</button>
										<button
											className="btn btn-sm btn-danger"
											title="Delete"
											onClick={() => handleDeleteMembership(membership?._id)}
										>
											<i className="far fa-trash-alt"></i>
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="3" className="text-center">
									No membership data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg" style={{ marginTop: '200px' }}>
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{editMode
										? 'Edit Membership type and Payment Details(UPI ID)'
										: 'Create New Membership type and Payment Details(UPI ID)'}
								</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditSansthaId(null)
										Formik.resetForm()
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={Formik.handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Membership Duration *</label>
												<select
													className="form-control"
													name="membershipType"
													value={Formik.values.membershipType}
													onChange={Formik.handleChange}
													onBlur={Formik.handleBlur}
												>
													<option value="">Select Duration</option>
													<option value="Monthly">Monthly</option>
													<option value="Yearly">Yearly</option>
													<option value="Lifetime">Lifetime</option>
													<option value="Free( Honorary) with voting right">
														Free( Honorary) with voting right
													</option>
													<option value="Family member ( free and without voting right)">
														Family member ( free and without voting right)
													</option>
												</select>
												{Formik.touched.membershipType && Formik.errors.membershipType ? (
													<div className="text-danger">{Formik.errors.membershipType}</div>
												) : null}
											</div>
										</div>

										<div className="col-md-6">
											<div className="form-group">
												{Formik.values.membershipType === 'Free( Honorary) with voting right' ||
												Formik.values.membershipType ===
													'Family member ( free and without voting right)' ? (
													<>
														<label> Reason *</label>
														<input
															type="text"
															className="form-control"
															name="honoraryReason"
															value={Formik.values.honoraryReason || ''}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.honoraryReason && Formik.errors.honoraryReason ? (
															<div className="text-danger">{Formik.errors.honoraryReason}</div>
														) : null}
													</>
												) : (
													<>
														<label>Membership Fee *</label>
														<input
															type="number"
															className="form-control"
															name="membershipfee"
															value={Formik.values.membershipfee}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.membershipfee && Formik.errors.membershipfee ? (
															<div className="text-danger">{Formik.errors.membershipfee}</div>
														) : null}
													</>
												)}
											</div>
										</div>
									</div>

									<div className="modal-footer">
										<button
											className="btn btn-labeled btn-success"
											type="submit"
											onClick={Formik.handleSubmit}
										>
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Create'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditSansthaId(null)
												Formik.resetForm()
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
export default MembershipPaymentdetailsTab
